export const hasCompletedTutorial = (state) => state.hasCompletedTutorial;
// TODO: check whether tutorialStep is still needed and remove it if not
export const tutorialStep = (state) => state.tutorialStep;
export const recommendedCompanies = (state) => state.recommendedCompanies;
export const recommendedCompaniesLoading = (state) =>
  state.recommendedCompaniesLoading;
export const recommendedCompaniesSearchQuery = (state) =>
  state.recommendedCompaniesSearchQuery;
export const nextCompaniesLoading = (state) => state.nextCompaniesLoading;
export const recommendedProfiles = (state) => state.recommendedProfiles;
export const recommendedProfilesLoading = (state) =>
  state.recommendedProfilesLoading;
export const nextProfilesLoading = (state) => state.nextProfilesLoading;
export const tutorialLoading = (state) => state.tutorialLoading;
export const showMoreCompanies = (state) =>
  state.showMoreCompanies &&
  !state.recommendedCompaniesLoading &&
  !state.nextCompaniesLoading;
export const showMoreProfiles = (state) =>
  state.showMoreProfiles &&
  !state.nextProfilesLoading &&
  !state.recommendedProfilesLoading;
export const recommendedProfilesSearchQuery = (state) =>
  state.recommendedProfilesSearchQuery;
export const birthdateSuccess = (state) => state.birthdateSuccess;
export const userOnboardingQuestions = (state) => state.userOnboardingQuestions;
export const userOnboardingAnswers = (state) => state.userOnboardingAnswers;
export const onboardingTooltipsVisible = (state) =>
  state.onboardingTooltips.isVisible;
export const onboardingTooltipStep = (state) =>
  state.onboardingTooltips.activeStepIndex;
export const onboardingTooltipSteps = (state) => state.onboardingTooltips.steps;
